module.exports = __webpack_public_path__ + "img/ics_ellipse.d6acff45.svg";